/* global axios */
import ApiClient from './ApiClient';

class TasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, {
      params,
    });
  }

  counts() {
    return axios.get(`${this.url}/counts`);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(taskData) {
    return axios.post(this.url, { task: taskData });
  }

  update(id, taskData) {
    return axios.patch(`${this.url}/${id}`, { task: taskData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new TasksAPI();
